<!-- Full Page Loader -->
<div class="full-page-loader" *ngIf="isLoading">
  <div class="loader-content">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Loading first meeting data...</p>
  </div>
</div>

<!-- Loader Bar -->
<div style="height: 3px; width: 100%;">
  <mat-progress-bar *ngIf="isLoading" mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<!-- Content -->
<div class="firstmeeting-view-container" *ngIf="!isLoading">
  
  <!-- Header -->
  <div class="view-header">
    <div class="header-title">
      <button mat-icon-button (click)="goBack()" class="back-btn">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div>
        <h1>First Meeting Details</h1>
        <p class="subtitle" *ngIf="firstMeetingData?.client_name">{{ firstMeetingData.client_name }}</p>
      </div>
    </div>

    <div class="header-actions">
      <button mat-raised-button color="accent" (click)="downloadPDF()" [disabled]="isDownloadingPDF" class="action-btn">
        <mat-icon *ngIf="!isDownloadingPDF">download</mat-icon>
        <mat-icon *ngIf="isDownloadingPDF" class="spinner-icon">hourglass_empty</mat-icon>
        <span *ngIf="!isDownloadingPDF">Download PDF</span>
        <span *ngIf="isDownloadingPDF">Downloading...</span>
      </button>
      <button mat-raised-button color="primary" (click)="editFirstMeeting()" class="action-btn">
        <mat-icon>edit</mat-icon>
        Edit
      </button>
      <!-- <button mat-raised-button color="warn" (click)="deleteFirstMeeting()" class="action-btn">
        <mat-icon>delete</mat-icon>
        Delete
      </button> -->
    </div>
  </div>

  <!-- Main Content -->
  <div class="view-content" *ngIf="firstMeetingData">
    
    <!-- Client Information Section -->
    <div class="info-section">
      <div class="section-header">
        <mat-icon class="section-icon">person</mat-icon>
        <h2>Client Information</h2>
      </div>
      
      <div class="info-grid">
        <div class="info-item">
          <label>Client Name</label>
          <p class="info-value">{{ firstMeetingData.client_name }}</p>
        </div>
        
        <div class="info-item">
          <label>Phone Number</label>
          <p class="info-value">
            <a [href]="'tel:' + firstMeetingData.phone_number">{{ firstMeetingData.phone_number }}</a>
          </p>
        </div>
        
        <div class="info-item">
          <label>Email ID</label>
          <p class="info-value">
            <a [href]="'mailto:' + firstMeetingData.email">{{ firstMeetingData.email }}</a>
          </p>
        </div>
      </div>
    </div>

    <!-- Debit Information Section -->
    <div class="info-section" *ngIf="firstMeetingData.debt_info && firstMeetingData.debt_info.length > 0">
      <div class="section-header">
        <mat-icon class="section-icon">credit_card</mat-icon>
        <h2>Debit Information</h2>
        <span class="section-badge">{{ firstMeetingData.debt_info.length }} entries</span>
      </div>

      <div class="table-container">
        <table class="info-table">
          <thead>
            <tr>
              <th>Bank Name</th>
              <th>Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let debt of firstMeetingData.debt_info">
              <td>{{ debt.name }}</td>
              <td class="amount">{{ debt.balance | currency }}</td>
            </tr>
            <tr class="total-row">
              <td><strong>Total Debit</strong></td>
              <td class="amount"><strong>{{ getTotalDebt() | currency }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Income Information Section -->
    <div class="info-section" *ngIf="firstMeetingData.debtors_income || firstMeetingData.spouse_income || firstMeetingData.child_tax || firstMeetingData.rental_income || firstMeetingData.family_support || firstMeetingData.any_other_income">
      <div class="section-header">
        <mat-icon class="section-icon">attach_money</mat-icon>
        <h2>Family Income</h2>
      </div>

      <div class="info-grid">
        <div class="info-item" *ngIf="firstMeetingData.debtors_income">
          <label>Debtor's Income</label>
          <p class="info-value">{{ firstMeetingData.debtors_income }}</p>
        </div>
        
        <div class="info-item" *ngIf="firstMeetingData.spouse_income">
          <label>Spouse Income</label>
          <p class="info-value">{{ firstMeetingData.spouse_income }}</p>
        </div>
        
        <div class="info-item" *ngIf="firstMeetingData.child_tax">
          <label>Child Tax</label>
          <p class="info-value">{{ firstMeetingData.child_tax }}</p>
        </div>
        
        <div class="info-item" *ngIf="firstMeetingData.rental_income">
          <label>Rental Income</label>
          <p class="info-value">{{ firstMeetingData.rental_income }}</p>
        </div>
        
        <div class="info-item" *ngIf="firstMeetingData.family_support">
          <label>Family Support</label>
          <p class="info-value">{{ firstMeetingData.family_support }}</p>
        </div>
        
        <div class="info-item" *ngIf="firstMeetingData.any_other_income">
          <label>Any Other Income</label>
          <p class="info-value">{{ firstMeetingData.any_other_income }}</p>
        </div>
      </div>
    </div>

    <!-- Assets Section -->
    <div class="info-section">
      <div class="section-header">
        <mat-icon class="section-icon">home</mat-icon>
        <h2>Assets</h2>
      </div>

      <!-- Mortgages -->
      <div class="subsection" *ngIf="firstMeetingData.assets_info && firstMeetingData.assets_info.length > 0">
        <h3>Mortgages</h3>
        <div class="table-container">
          <table class="info-table">
            <thead>
              <tr>
                <th>Mortgage</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let mortgage of firstMeetingData.assets_info; let i = index">
                <td>{{ getMortgageLabel(i) }}</td>
                <td class="amount">{{ formatMortgageValue(mortgage.mortgage) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Property Value and LOP -->
      <div class="info-grid">
        <div class="info-item" *ngIf="firstMeetingData.property_value">
          <label>Property Value</label>
          <p class="info-value">{{ firstMeetingData.property_value | currency }}</p>
        </div>
        
        <div class="info-item">
          <label>LOP Needed</label>
          <p class="info-value">
            <mat-chip [ngClass]="firstMeetingData.lop_needed === 1 ? 'chip-success' : 'chip-danger'">
              {{ firstMeetingData.lop_needed === 1 ? 'YES' : 'NO' }}
            </mat-chip>
          </p>
        </div>
      </div>
    </div>

    <!-- Vehicle Information Section -->
    <div class="info-section" *ngIf="firstMeetingData.vehicle_model || firstMeetingData.vehicle_year || firstMeetingData.vehicle_finance_amount">
      <div class="section-header">
        <mat-icon class="section-icon">directions_car</mat-icon>
        <h2>Vehicle Information</h2>
      </div>

      <div class="info-grid">
        <div class="info-item" *ngIf="firstMeetingData.vehicle_model">
          <label>Vehicle Model</label>
          <p class="info-value">{{ firstMeetingData.vehicle_model }}</p>
        </div>
        
        <div class="info-item" *ngIf="firstMeetingData.vehicle_year">
          <label>Vehicle Year</label>
          <p class="info-value">{{ firstMeetingData.vehicle_year }}</p>
        </div>
        
        <div class="info-item" *ngIf="firstMeetingData.vehicle_finance_amount">
          <label>Finance Amount</label>
          <p class="info-value">{{ firstMeetingData.vehicle_finance_amount | currency }}</p>
        </div>
      </div>
    </div>

    <!-- Business Information Section -->
    <div class="info-section" *ngIf="firstMeetingData.bsns_name || firstMeetingData.bsns_hst || firstMeetingData.bsns_article_ins || firstMeetingData.bsns_deal">
      <div class="section-header">
        <mat-icon class="section-icon">business</mat-icon>
        <h2>Business Information</h2>
      </div>

      <div class="info-grid">
        <div class="info-item" *ngIf="firstMeetingData.bsns_name">
          <label>Business Name</label>
          <p class="info-value">{{ firstMeetingData.bsns_name || 'N/A' }}</p>
        </div>
        
        <div class="info-item" *ngIf="firstMeetingData.bsns_hst">
          <label>HST Number</label>
          <p class="info-value">{{ firstMeetingData.bsns_hst || 'N/A' }}</p>
        </div>
        
        <div class="info-item" *ngIf="firstMeetingData.bsns_article_ins">
          <label>Article of Incorporation</label>
          <p class="info-value">{{ firstMeetingData.bsns_article_ins || 'N/A' }}</p>
        </div>
        
        <div class="info-item" *ngIf="firstMeetingData.bsns_deal">
          <label>Business Debit</label>
          <p class="info-value">{{ firstMeetingData.bsns_deal | currency }}</p>
        </div>
      </div>
    </div>

    <!-- Notes Section -->
    <div class="info-section" *ngIf="firstMeetingData.notes">
      <div class="section-header">
        <mat-icon class="section-icon">note</mat-icon>
        <h2>Notes</h2>
      </div>

      <div class="notes-content">
        <p>{{ firstMeetingData.notes }}</p>
      </div>
    </div>

    <!-- Terms Section -->
    <div class="info-section" *ngIf="firstMeetingData.terms">
      <div class="section-header">
        <mat-icon class="section-icon">description</mat-icon>
        <h2>Terms and Conditions</h2>
      </div>

      <div class="notes-content">
        <p>{{ firstMeetingData.terms }}</p>
      </div>
    </div>

  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!isLoading && !firstMeetingData">
    <mat-icon class="empty-icon">info</mat-icon>
    <h3>No Data Available</h3>
    <p>The first meeting data could not be loaded.</p>
    <button mat-raised-button color="primary" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Go Back
    </button>
  </div>
</div>
